<!-- BETA-CLEANUP: delete this file once Vue 3 is the only app -->
<template>
  <div class="profile-menu-beta-promo primary--text pa-4">
    <div class="d-flex align-center">
      <BetaRocketIcon class="mr-2" />
      <span class="subtitle-1 font-weight-medium">New SlickCactus</span>
      <CommonChip color="primary" class="ml-2">New</CommonChip>
    </div>
    <p class="body-2 text--secondary mt-2 mb-3">
      A redesigned app with the same data and sign-in. We'll open it for you until you switch back from its profile menu.
    </p>
    <p v-if="releaseNote" class="body-2 font-weight-medium mt-n1 mb-3" data-test="beta-promo-release">
      {{ releaseNote }}
    </p>
    <v-btn
      color="primary"
      depressed
      block
      :loading="isOpeningBeta"
      data-test="open-beta"
      data-track="beta.profile-menu.open"
      @click="openBeta"
    >
      Try the new version
      <v-icon right>mdi-arrow-right</v-icon>
    </v-btn>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

import { getBetaReleaseNote, openBeta } from '@/bundles/App/helpers/betaChannel';

import BetaRocketIcon from '@/bundles/App/components/BetaRocketIcon.vue';
import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

interface IData {
  releaseNote: string;
  isOpeningBeta: boolean;
}

export default Vue.extend({
  name: 'ProfileMenuBetaPromo',

  components: { BetaRocketIcon, CommonChip },

  data: (): IData => ({
    releaseNote: getBetaReleaseNote(),
    isOpeningBeta: false,
  }),

  methods: {
    async openBeta (): Promise<void> {
      this.isOpeningBeta = true;

      try {
        await openBeta();
      } finally {
        this.isOpeningBeta = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
// a light tint of the primary colour that reads in both themes, like Vuetify's text alerts
.profile-menu-beta-promo {
  position: relative;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: currentColor;
    opacity: 0.08;
    pointer-events: none;
  }
}
</style>
